"use strict";

exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.number.parse-float.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.set.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.map.js");
var _utils = require("../utils");
var _event = require("../utils/event");
var _touch = require("../mixins/touch");
var _mouse = require("../mixins/mouse");
var adapter;
if (!_utils.isServer) {
  adapter = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}

var _use = (0, _utils.use)('swipe'),
  sfc = _use[0],
  bem = _use[1];
var isPC = !_utils.isServer && window && !('ontouchstart' in window);
var _default = sfc({
  mixins: [_touch.TouchMixin, _mouse.MouseMixin],
  props: {
    width: [Number, String],
    swipeDistance: {
      type: Number,
      default: 50
    },
    height: Number,
    center: Boolean,
    autoplay: Number,
    lazyRender: Boolean,
    vertical: Boolean,
    adaptHeight: Boolean,
    initialSwipe: Number,
    indicatorColor: String,
    loop: {
      type: Boolean,
      default: true
    },
    touchable: {
      type: Boolean,
      default: true
    },
    showCheckMore: {
      type: Boolean,
      default: false
    },
    checkMoreText: {
      type: String,
      default: '查看更多'
    },
    showIndicators: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 500
    },
    nativeSwipe: {
      type: Boolean,
      default: false
    },
    multiScrollerTab: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      offsetWidth: 0,
      computedWidth: 0,
      computedHeight: 0,
      offset: 0,
      active: 0,
      deltaX: 0,
      deltaY: 0,
      swipes: [],
      swiping: false,
      touchTimeStamp: 0,
      isMoveLock: false,
      offsetTop: 0,
      movingCtx: {
        isMoving: false,
        scrollTop: 0,
        isCover: !1,
        height: -1,
        index: -1
      },
      moveAffectedItems: [],
      itemCoverOffsets: [],
      isIndexChange: false,
      coverHeight: 0,
      notGesture: false,
      canJump: false,
      outOfBounds: false
    };
  },
  mounted: function mounted() {
    this.initialize();
    if (this.multiScrollerTab) {
      this.resetScrollTop(0);
    }
    if (!_utils.isServer && this.$expandAdapter) adapter = this.$expandAdapter;
    if (!this.$isServer) {
      (0, _event.on)(window, 'resize', this.onResize, true);
    }
  },
  activated: function activated() {
    if (this.rendered) {
      this.initialize();
    }
    this.rendered = true;
  },
  destroyed: function destroyed() {
    this.clear();
    if (!this.$isServer) {
      (0, _event.off)(window, 'resize', this.onResize, true);
    }
  },
  watch: {
    swipes: function swipes() {
      this.initialize();
    },
    initialSwipe: function initialSwipe() {
      this.initialize();
    },
    autoplay: function autoplay(_autoplay) {
      if (!_autoplay) {
        this.clear();
      } else {
        this.autoPlay();
      }
    },
    active: function active() {
      if (this.multiScrollerTab && this.notGesture) {
        this.isMoveLock = false;
        this.moveUnLock();
      }
    }
  },
  computed: {
    count: function count() {
      return this.swipes.length;
    },
    delta: function delta() {
      return this.vertical ? this.deltaY : this.deltaX;
    },
    size: function size() {
      return this[this.vertical ? 'computedHeight' : 'computedWidth'];
    },
    trackSize: function trackSize() {
      return this.count * this.size;
    },
    activeIndicator: function activeIndicator() {
      return (this.active + this.count) % this.count;
    },
    isCorrectDirection: function isCorrectDirection() {
      var expect = this.vertical ? 'vertical' : 'horizontal';
      return this.direction === expect;
    },
    trackStyle: function trackStyle() {
      var mainAxis = this.vertical ? 'height' : 'width';
      var crossAxis = this.vertical ? 'width' : 'height';
      if (this.multiScrollerTab) {
        return {
          flexDirection: this.vertical ? 'column' : 'row',
          width: '100%',
          transitionDuration: (this.swiping || this.notGesture ? 0 : this.duration || 300) + "ms",
          transform: "translate3d(" + (this.vertical ? 0 : this.offset + 'px') + ", " + (this.vertical ? this.offset + 'px' : 0) + ", 0)"
        };
      } else {
        var _ref;
        return _ref = {
          flexDirection: this.vertical ? 'column' : 'row'
        }, _ref[mainAxis] = this.trackSize + "px", _ref[crossAxis] = this[crossAxis] ? this[crossAxis] + "px" : '', _ref.transitionDuration = (this.swiping ? 0 : this.duration) + "ms", _ref.transform = "translate3d(" + (this.vertical ? 0 : this.offset + 'px') + ", " + (this.vertical ? this.offset + 'px' : 0) + ", 0)", _ref;
      }
    }
  },
  methods: {
    // initialize swipe position
    initialize: function initialize(active) {
      if (active === void 0) {
        active = this.initialSwipe;
      }
      clearTimeout(this.timer);
      if (this.$el) {
        var rect = this.$el.getBoundingClientRect();
        this.computedWidth = this.calWidth(rect.width);
        this.computedHeight = this.height || rect.height;
        if (this.center) {
          this.offsetWidth = (rect.width - this.computedWidth) / 2;
        }
      }
      if (this.multiScrollerTab) {
        this.coverHeight = this.$parent.getBottomOffsetTop() || 42.06;
        this.itemCoverOffsets = Array.from({
          length: this.$children.length
        }).fill(0);
      }
      this.swiping = true;
      this.active = active;
      this.offset = this.count > 1 ? -this.size * this.active + this.offsetWidth : this.offsetWidth;
      this.swipes.forEach(function (swipe) {
        swipe.offset = 0;
      });
      this.autoPlay();
    },
    calWidth: function calWidth(width) {
      if (typeof this.width === 'string') {
        return Number.parseFloat(this.width) * 0.01 * width;
      }
      return this.width || width;
    },
    onResize: function onResize() {
      this.initialize(this.activeIndicator);
    },
    onTouchStart: function onTouchStart(event) {
      this.notGesture = false;
      if (!this.touchable) return;
      this.interceptZLJAndrTouch(true);
      this.clear();
      this.swiping = true;
      this.touchTimeStamp = +new Date();
      this.touchStart(event);
      this.correctPosition();
      if (this.nativeSwipe && !this.loop) {
        if (this.active > 0) {
          // 如果不是在第一页，禁止侧滑返回，防止用户在滑动切换的时候触发侧滑返回
          this.stopPageGestureBack();
        } else {
          // 如果是在第一页，开启侧滑返回，让用户在滑动切换的时候可以触发侧滑返回
          this.startPageGestureBack();
        }
      }
    },
    onTouchMove: function onTouchMove(event) {
      this.notGesture = false;
      if (!this.touchable || !this.swiping) return;
      this.interceptZLJAndrTouch(false);
      this.touchMove(event);
      if (this.isCorrectDirection) {
        (0, _event.preventDefault)(event, true);
        this.move({
          offset: Math.min(Math.max(this.delta, -this.size), this.size),
          index: this.active
        });
      }
    },
    onTouchEnd: function onTouchEnd() {
      var _this = this;
      this.notGesture = false;
      if (!this.touchable || !this.swiping) return;
      // 如果是nativeSwipe横向不循环情况下，
      // 第一页如果滑动距离是负值小于swipeDistance，
      // 且滑动起始位置小于swipeDistance的10%
      // 认为是系统侧滑，不做移动
      if (this.nativeSwipe && !this.vertical && !this.loop && this.active === 0 && this.deltaX < -this.swipeDistance && this.startX < this.swipeDistance * 0.1) {
        return;
      }
      if (this.delta && this.isCorrectDirection) {
        var offset = this.vertical ? this.offsetY : this.offsetX;
        if (this.multiScrollerTab) {
          Promise.resolve().then(function () {
            _this.move({
              pace: offset > _this.swipeDistance ? _this.delta > 0 ? -1 : 1 : 0,
              emitChange: true,
              index: _this.active
            });
          });
        } else {
          this.move({
            pace: offset > this.swipeDistance ? this.delta > 0 ? -1 : 1 : 0,
            emitChange: true
          });
        }
      }
      this.swiping = false;
      this.autoPlay();
      if (this.nativeSwipe && !this.loop) {
        this.startPageGestureBack();
      }

      // b2c轮播图最后一张查看更多逻辑
      if (this.outOfBounds) {
        if (this.showCheckMore && !this.loop) {
          var checkMoreDom = document.querySelector('.z-swipe__check-more');
          checkMoreDom.style.transition = 'all 0.2s  ease-in-out';
          checkMoreDom.style.transform = 'translateX(0px)';
        }
      }

      // 查看更多跳转
      if (this.canJump && Math.abs(this.deltaX) > 80) {
        this.canJump = false;
        this.$emit('checkMore', this.deltaX);
      }
    },
    onMouseDown: function onMouseDown(event) {
      var _this2 = this;
      this.notGesture = false;
      if (!this.touchable) return;
      this.clear();
      this.swiping = true;
      this.mouseDown(event);
      this.correctPosition();
      document.addEventListener('mousemove', this.onMouseMove);
      var mouseup = function mouseup() {
        _this2.onMouseUp();
        document.removeEventListener('mousemove', _this2.onMouseMove);
        document.removeEventListener('mouseup', mouseup);
      };
      document.addEventListener('mouseup', mouseup);
    },
    onMouseMove: function onMouseMove(event) {
      this.notGesture = false;
      if (!this.touchable || !this.swiping) return;
      this.mouseMove(event);
      if (this.isCorrectDirection) {
        (0, _event.preventDefault)(event, true);
        if (this.multiScrollerTab) {
          this.move({
            offset: Math.min(Math.max(this.delta, -this.size), this.size),
            index: this.active
          });
        } else {
          this.move({
            offset: Math.min(Math.max(this.delta, -this.size), this.size)
          });
        }
      }
    },
    onMouseUp: function onMouseUp() {
      this.notGesture = false;
      if (!this.touchable || !this.swiping) return;
      if (this.delta && this.isCorrectDirection) {
        var offset = this.vertical ? this.offsetY : this.offsetX;
        if (this.multiScrollerTab) {
          this.move({
            pace: offset > this.swipeDistance ? this.delta > 0 ? -1 : 1 : 0,
            emitChange: true,
            index: this.active
          });
        } else {
          this.move({
            pace: offset > this.swipeDistance ? this.delta > 0 ? -1 : 1 : 0,
            emitChange: true
          });
        }
      }
      this.swiping = false;
      this.autoPlay();
    },
    move: function move(_ref2) {
      var _ref2$pace = _ref2.pace,
        pace = _ref2$pace === void 0 ? 0 : _ref2$pace,
        _ref2$offset = _ref2.offset,
        offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
        emitChange = _ref2.emitChange,
        notGesture = _ref2.notGesture,
        index = _ref2.index,
        _ref2$autoplay = _ref2.autoplay,
        autoplay = _ref2$autoplay === void 0 ? false : _ref2$autoplay;
      if (this.multiScrollerTab) {
        this.isIndexChange = index !== this.active;
        if (notGesture) {
          this.isMoveLock = false;
        }
        this.isMoveLock || (notGesture && this.isIndexChange ? this.moveLock(index) : this.moveLock(-1));
      }
      var delta = this.delta,
        active = this.active,
        count = this.count,
        swipes = this.swipes,
        trackSize = this.trackSize;
      var atFirst = active === 0;
      var atLast = active === count - 1;
      var outOfBounds = !this.loop && (atFirst && (offset > 0 || pace < 0) || atLast && (offset < 0 || pace > 0));

      // b2c 轮播图最后一张左滑查看更多逻辑
      if (atLast && this.showCheckMore && !this.loop) {
        this.outOfBounds = true;
      }
      if (outOfBounds || count <= 1) {
        // 显示查看更多逻辑
        var checkMoreDom = document.querySelector('.z-swipe__check-more');
        var canTouchRight = this.showCheckMore && offset > -80 && !(atFirst && (offset > 0 || pace < 0));
        if (canTouchRight) {
          this.offset = Math.round(offset - this.active * this.size + this.offsetWidth);
          checkMoreDom.style.transform = 'translateX(-30px)';
          this.canJump = true;
        }
        return;
      }
      if (swipes[0]) {
        swipes[0].offset = atLast && (delta < 0 || pace > 0) ? trackSize : 0;
      }
      if (swipes[count - 1]) {
        swipes[count - 1].offset = atFirst && (delta > 0 || pace < 0) ? -trackSize : 0;
      }
      if (pace && active + pace >= -1 && active + pace <= count) {
        this.active += pace;
        if (emitChange) {
          this.$emit('change', this.activeIndicator, autoplay);
          if (this.multiScrollerTab) {
            this.onTransitionEnd();
          }
        }
      } else if (this.nativeSwipe && !this.vertical) {
        // 如果是nativeSwipe横向不循环情况下，
        // 第一页如果滑动距离是负值小于swipeDistance，
        // 且滑动起始位置小于swipeDistance的10%
        // 认为是系统侧滑，不做移动
        if (!this.loop && this.active === 0 && this.deltaX < -this.swipeDistance && this.startX < this.swipeDistance * 0.1) {
          return;
        }
        // 触摸时间
        var touchTime = +new Date() - this.touchTimeStamp;
        // 偏移距离
        var touchDelta = Math.abs(this.delta);
        // 触摸速度
        var touchSpeed = touchDelta / touchTime;
        // 强制切换
        var fastForceSwipe = false;
        // 快速滑动：如果滑动结束，偏移距离大于等于限定滑动距离的10%，且速度大于0，3，认为是快速滑动，应该切换
        if (emitChange && touchDelta >= this.swipeDistance * 0.1 && touchSpeed > 0.3) {
          var targetActive = this.active + (this.delta > 0 ? -1 : 1);
          if (targetActive >= 0 && targetActive < count) {
            fastForceSwipe = true;
            this.$emit('move', {
              active: this.active,
              pace: this.delta > 0 ? -1 : 1
            });
            this.active = targetActive;
            this.$emit('change', this.activeIndicator, autoplay);
            if (this.multiScrollerTab) {
              this.onTransitionEnd();
            }
          }
        }
        // 慢速滑动：如果不是快速切换，则根据滑动偏移是否超出限定距离来决定是否切换
        if (!fastForceSwipe) {
          this.$emit('move', {
            active: this.active,
            pace: Math.abs(offset) > this.swipeDistance ? this.delta > 0 ? -1 : 1 : 0
          });
        }
      }
      this.offset = Math.round(offset - this.active * this.size + this.offsetWidth);
    },
    moveUnLock: function moveUnLock() {
      var _this3 = this;
      if (this.isMoveLock) {
        this.isMoveLock = false;
      }
      this.updateMovingCtx();
      var resArray = new Set([].concat(this.moveAffectedItems, [this.active - 1, this.active, this.active + 1]));
      Array.from(resArray).filter(function (e) {
        var _this3$$children;
        return e > -1 && e < ((_this3$$children = _this3.$children) === null || _this3$$children === void 0 ? void 0 : _this3$$children.length);
      }).forEach(function (e) {
        _this3.setTabElStyle(_this3.getTabState(e));
      });
      if (this.movingCtx.isCover) {
        var scrollTop = this.itemCoverOffsets[this.active] + Math.min(this.offsetTop - this.coverHeight, this.movingCtx.scrollTop);
        this.resetScrollTop(scrollTop);
      }
    },
    resetScrollTop: function resetScrollTop(top) {
      document.body.scrollTop = top;
      document.documentElement && (document.documentElement.scrollTop = top);
    },
    moveLock: function moveLock(active) {
      var _this4 = this;
      this.isMoveLock = true;
      this.updateMovingCtx();
      this.itemCoverOffsets[this.active] = this.movingCtx.coverOffset;
      this.moveAffectedItems = (active === -1 ? [this.active - 1, this.active + 1] : [active]).filter(function (e) {
        var _this4$$children;
        return e > -1 && e < ((_this4$$children = _this4.$children) === null || _this4$$children === void 0 ? void 0 : _this4$$children.length);
      });
      this.moveAffectedItems.forEach(function (e) {
        _this4.setTabElStyle(_this4.getTabState(e, true));
      });
      this.moveAffectedItems.push(this.active);
    },
    getTabState: function getTabState(index, state) {
      if (this.active === index) {
        return {
          tabIndex: index,
          style: {},
          innerStyle: {
            display: 'block',
            transformY: 0
          }
        };
      }
      if (state) {
        var top = 0;
        this.isMoveLock && (top = this.movingCtx.isCover ? this.itemCoverOffsets[index] - this.movingCtx.coverOffset : 0);
        return {
          tabIndex: index,
          style: {
            height: this.isMoveLock ? this.movingCtx.height : 1
          },
          innerStyle: {
            display: 'block',
            transformY: top
          }
        };
      }
      return {
        tabIndex: index,
        style: {
          height: 1
        },
        innerStyle: {
          display: 'none',
          transformY: 0
        }
      };
    },
    setTabElStyle: function setTabElStyle(tabState) {
      var _this$$children$tabSt, _tabState$innerStyle, _tabState$innerStyle2, _tabState$innerStyle3;
      var child = (_this$$children$tabSt = this.$children[tabState.tabIndex]) === null || _this$$children$tabSt === void 0 ? void 0 : _this$$children$tabSt.$el;
      var firstChild = child === null || child === void 0 ? void 0 : child.firstChild;
      if (child !== null && child !== void 0 && child.style) {
        var _tabState$style, _tabState$style2;
        child.style.height = tabState !== null && tabState !== void 0 && (_tabState$style = tabState.style) !== null && _tabState$style !== void 0 && _tabState$style.height ? ''.concat(tabState === null || tabState === void 0 ? void 0 : (_tabState$style2 = tabState.style) === null || _tabState$style2 === void 0 ? void 0 : _tabState$style2.height, 'px') : 'auto';
      }
      var style = {};
      (tabState === null || tabState === void 0 ? void 0 : (_tabState$innerStyle = tabState.innerStyle) === null || _tabState$innerStyle === void 0 ? void 0 : _tabState$innerStyle.display) === 'none' && (style.display = 'none');
      style.top = ''.concat(-(tabState === null || tabState === void 0 ? void 0 : (_tabState$innerStyle2 = tabState.innerStyle) === null || _tabState$innerStyle2 === void 0 ? void 0 : _tabState$innerStyle2.transformY), 'px');
      (tabState === null || tabState === void 0 ? void 0 : (_tabState$innerStyle3 = tabState.innerStyle) === null || _tabState$innerStyle3 === void 0 ? void 0 : _tabState$innerStyle3.display) !== 'none' && (style.display = 'block');
      if (firstChild) {
        Object.assign(firstChild.style, style);
      }
    },
    getDocumentScrollTop: function getDocumentScrollTop() {
      return document.body.scrollTop || document.documentElement.scrollTop || 0;
    },
    updateMovingCtx: function updateMovingCtx() {
      var documentScrollTop = this.getDocumentScrollTop();
      var rect = this.$el.getBoundingClientRect();
      var rectTop = Math.round(rect.top);
      this.offsetTop = documentScrollTop + rectTop;
      var cover = documentScrollTop - (this.offsetTop - this.coverHeight);
      this.movingCtx = {
        isMoving: true,
        scrollTop: documentScrollTop,
        index: this.active || 0,
        isCover: cover > -1,
        height: Math.round(rect.height) || this.movingCtx.height,
        coverOffset: Math.max(0, cover)
      };
    },
    swipeTo: function swipeTo(index) {
      var _this5 = this;
      this.notGesture = true;
      this.isMoveLock = false;
      this.swiping = true;
      this.resetTouchStatus();
      this.correctPosition();
      setTimeout(function () {
        _this5.swiping = false;
        _this5.isMoveLock = true;
        _this5.move({
          pace: index % _this5.count - _this5.active,
          emitChange: true,
          notGesture: true,
          index: index
        });
      }, 30);
    },
    correctPosition: function correctPosition() {
      if (this.active <= -1) {
        this.move({
          pace: this.count
        });
      }
      if (this.active >= this.count) {
        this.move({
          pace: -this.count
        });
      }
    },
    clear: function clear() {
      clearTimeout(this.timer);
    },
    autoPlay: function autoPlay() {
      var _this6 = this;
      var autoplay = this.autoplay;
      if (autoplay && this.count > 1) {
        this.clear();
        this.timer = setTimeout(function () {
          _this6.swiping = true;
          _this6.resetTouchStatus();
          _this6.correctPosition();
          setTimeout(function () {
            _this6.swiping = false;
            _this6.move({
              pace: 1,
              emitChange: true,
              index: _this6.active,
              autoplay: true
            });
            _this6.autoPlay();
          }, 30);
        }, autoplay);
      }
    },
    interceptZLJAndrTouch: function interceptZLJAndrTouch(isIntercept) {
      if (adapter.in('zlj') && _utils.isAndroid) {
        // 调用ZLJAPP 安卓客户端的能力，屏蔽客户端原生触发事件
        // https://m.zhuanzhuan.com/common/zlj-js-sdk/#/docs
        adapter.wrap('dispatchTouchViewPager')({
          isIntercept: isIntercept
        });
      }
    },
    stopPageGestureBack: function stopPageGestureBack() {
      if (adapter.in('zz')) {
        adapter.wrap('setPageGestureBackAction')({
          slipStatus: 0
        });
      }
    },
    onTransitionEnd: function onTransitionEnd() {
      this.isMoveLock = false;
      this.moveUnLock();
    },
    startPageGestureBack: function startPageGestureBack() {
      if (adapter.in('zz')) {
        adapter.wrap('setPageGestureBackAction')({
          slipStatus: 1
        });
      }
    }
  },
  render: function render(h) {
    var _this7 = this;
    var count = this.count,
      activeIndicator = this.activeIndicator;
    // console.log('isPC', isPC)
    var Indicator = this.slots('indicator') || this.showIndicators && count > 1 && h("div", {
      "class": bem('indicators', {
        vertical: this.vertical
      })
    }, [Array.apply(void 0, Array(count)).map(function (empty, index) {
      return h("i", {
        "class": bem('indicator', {
          active: index === activeIndicator
        }),
        "style": {
          backgroundColor: _this7.indicatorColor
        }
      });
    })]);
    return isPC ? h("div", {
      "class": bem()
    }, [h("div", {
      "ref": "track",
      "style": this.trackStyle,
      "class": bem('track'),
      "on": {
        "mousedown": this.onMouseDown
      }
    }, [this.slots()]), Indicator, this.showCheckMore && !this.loop && h("div", {
      "class": bem('check-more'),
      "ref": "checkMoreRef"
    }, [h("img", {
      "attrs": {
        "src": "https://pic1.zhuanstatic.com/zhuanzh/b9dc493d-8513-49d6-aac6-beed2135cda2.png",
        "alt": ""
      }
    }), h("span", {
      "class": "text"
    }, [this.checkMoreText])])]) : h("div", {
      "class": bem()
    }, [h("div", {
      "ref": "track",
      "style": this.trackStyle,
      "class": bem('track'),
      "on": {
        "touchstart": this.onTouchStart,
        "touchmove": this.onTouchMove,
        "touchend": this.onTouchEnd,
        "touchcancel": this.onTouchEnd
      }
    }, [this.slots(), this.showCheckMore && !this.loop && h("div", {
      "class": bem('check-more')
    }, [h("img", {
      "attrs": {
        "src": "https://pic1.zhuanstatic.com/zhuanzh/b9dc493d-8513-49d6-aac6-beed2135cda2.png",
        "alt": ""
      }
    }), h("span", {
      "class": "text"
    }, [this.checkMoreText])])]), Indicator]);
  }
});
exports.default = _default;